import { useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { ArrowUpRight, Menu, X } from 'lucide-react'
import Logo from './Logo'

const links = [
  ['About', '/about'],
  ['Programs', '/programs'],
  ['Methodology', '/methodology'],
  ['Corporate', '/corporate-training'],
  ['Taksha AI', '/taksha-ai'],
]

export default function Header() {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()

  return (
    <header className="site-header">
      <div className="container header__inner">
        <Logo />
        <nav className={`main-nav ${open ? 'main-nav--open' : ''}`} aria-label="Primary navigation">
          {links.map(([label, to]) => (
            <NavLink key={to} to={to} onClick={() => setOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>{label}</NavLink>
          ))}
          <Link className="button button--small nav-cta" to="/contact" onClick={() => setOpen(false)}>
            Talk to us <ArrowUpRight size={16} />
          </Link>
        </nav>
        <button className="menu-button" aria-label={open ? 'Close navigation' : 'Open navigation'} aria-expanded={open} onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && <button className="nav-scrim" aria-label="Close navigation" onClick={() => setOpen(false)} />}
      <span className="route-marker" key={pathname} />
    </header>
  )
}
